import { Icon } from 'app/components/Icon';
import styles from './PageHeader.module.scss';

interface PageHeaderI {
  iconName: string;
  size?: string;
  title: string;
}
export const PageHeader = ({ iconName, title, size }: PageHeaderI) => {
  return (
    <div className={styles.heading_container}>
      <Icon name={iconName} size={size} color={'var(--default-primary)'} />
      <span className={styles.heading}>{title}</span>
    </div>
  );
};
